/**
 * Alias de una ruta pública en español hacia su ruta canónica en inglés.
 *
 * Los segmentos de ruta son siempre en inglés (docs/design.md 16.4). Estos alias
 * se conservan **solo** para que un enlace ya enviado no quede roto: no son un
 * destino, son un reenvío. Por eso todos pasan por aquí en vez de declarar un
 * `<Navigate>` cada uno, y por eso el reenvío **conserva el fragmento**: sin él,
 * un correo antiguo con `/establecer-contrasena#token=…` aterrizaría en
 * "enlace no válido" en lugar de mostrar el formulario, que es el peor resultado
 * posible para alguien que sí está siguiendo el procedimiento correcto.
 *
 * El hash se lee en un efecto y no durante el render: leer `window` al renderizar
 * rompe cualquier renderizado fuera del navegador (pruebas, generación de markup)
 * y además congelaría el valor, porque si el hash cambiara después la ruta ya
 * calculada no se volvería a evaluar.
 */
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { withHashToken } from './withHashToken';

export function LegacyAliasRedirect({ to }: { to: string }) {
  const [target, setTarget] = useState(() => to);
  useEffect(() => {
    setTarget(withHashToken(window.location.hash, to));
  }, [to]);
  return <Navigate to={target} replace />;
}
